import * as Mod1 from "./discourse/components/mod-market-banner";
import * as Mod2 from "./discourse/components/mod-market-card";
import * as Mod3 from "./discourse/components/mod-market-composer-collapse";
import * as Mod4 from "./discourse/components/mod-market-contextual-banner";
import * as Mod5 from "./discourse/components/mod-market-gallery";
import * as Mod6 from "./discourse/components/mod-market-route-status";
import * as Mod7 from "./discourse/connectors/topic-above-footer-buttons/mod-market-embed-composer.gjs";
import * as Mod8 from "./discourse/controllers/mod-market-show";
import * as Mod9 from "./discourse/controllers/mod-market";
import * as Mod10 from "./discourse/discourse-mod-market-route-map";
import * as Mod11 from "./discourse/initializers/discourse-mod-market-contextual-banner";
import * as Mod12 from "./discourse/initializers/discourse-mod-market-embed-composer";
import * as Mod13 from "./discourse/lib/mod-market-composer-messages";
import * as Mod14 from "./discourse/routes/mod-market-show";
import * as Mod15 from "./discourse/routes/mod-market";
import * as Mod16 from "./discourse/templates/mod-market-error";
import * as Mod17 from "./discourse/templates/mod-market-loading";
import * as Mod18 from "./discourse/templates/mod-market-show-error";
import * as Mod19 from "./discourse/templates/mod-market-show-loading";
import * as Mod20 from "./discourse/templates/mod-market-show";
import * as Mod21 from "./discourse/templates/mod-market";
const compatModules = {
  "discourse/components/mod-market-banner": Mod1,
  "discourse/components/mod-market-card": Mod2,
  "discourse/components/mod-market-composer-collapse": Mod3,
  "discourse/components/mod-market-contextual-banner": Mod4,
  "discourse/components/mod-market-gallery": Mod5,
  "discourse/components/mod-market-route-status": Mod6,
  "discourse/connectors/topic-above-footer-buttons/mod-market-embed-composer": Mod7,
  "discourse/controllers/mod-market-show": Mod8,
  "discourse/controllers/mod-market": Mod9,
  "discourse/discourse-mod-market-route-map": Mod10,
  "discourse/initializers/discourse-mod-market-contextual-banner": Mod11,
  "discourse/initializers/discourse-mod-market-embed-composer": Mod12,
  "discourse/lib/mod-market-composer-messages": Mod13,
  "discourse/routes/mod-market-show": Mod14,
  "discourse/routes/mod-market": Mod15,
  "discourse/templates/mod-market-error": Mod16,
  "discourse/templates/mod-market-loading": Mod17,
  "discourse/templates/mod-market-show-error": Mod18,
  "discourse/templates/mod-market-show-loading": Mod19,
  "discourse/templates/mod-market-show": Mod20,
  "discourse/templates/mod-market": Mod21,
};
export default compatModules;
